import React from "react";
import SectionContentBox from "../components/SectionContentBox";
import {useLanguage} from "../hooks/LanguageContext";
import BookingForm from "../components/booking/BookingForm";

const BookingPage = () => {
    const { direction, language } = useLanguage(); // Get language direction (ltr/rtl) and language

    return (
        <div className="md:mt-60 container">
            <section className={`container ${direction === "rtl" ? "text-right" : "text-left"}`}>
                <SectionContentBox
                    justify="justify-center"
                    className="mt-8"
                    width="w-full mx-auto"
                    align="items-center"
                    title={language === "ar" ? "حجز شحن\n" : "Contact Us"}
                    hasTowLines={true}
                    hideBtn={true}
                />
            </section>
            <BookingForm/>
        </div>

    );
};

export default BookingPage;
